import { render, staticRenderFns } from "./oportunidade.vue?vue&type=template&id=4d02af49&scoped=true&"
import script from "./oportunidade.vue?vue&type=script&lang=js&"
export * from "./oportunidade.vue?vue&type=script&lang=js&"
import style0 from "./oportunidade.vue?vue&type=style&index=0&id=4d02af49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d02af49",
  null
  
)

export default component.exports
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QTime from 'quasar/src/components/time/QTime.js';
import QRating from 'quasar/src/components/rating/QRating.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QFab from 'quasar/src/components/fab/QFab.js';
import QFabAction from 'quasar/src/components/fab/QFabAction.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QLayout,QCardSection,QBadge,QExpansionItem,QInput,QIcon,QBtn,QSpace,QSeparator,QSelect,QCardActions,QTooltip,QPopupProxy,QDate,QTime,QRating,QCard,QToggle,QPageSticky,QFab,QFabAction,QDialog});qInstall(component, 'directives', {ClosePopup});
